import React, { useEffect, useState } from "react";
import T from "prop-types";
import { get } from "lodash";
import { renderIf } from "MODULES/shared/decorators";
import { Link } from "react-router-dom";
import api from "APP_ROOT/api";
import { ID } from "APP_ROOT/constants";
import { fromJS } from "immutable";
import { ACTION_REQUESTED, SHOP_ASSIST } from "../../../constants";
import { Table } from "./Table";
import { dollars } from "../../../../../lib/formatters/currency";

function HigherAssemblyTable({ repairOrder: basicRepairOrder }) {
  const [repairOrder, setRepairOrder] = useState(null);

  useEffect(
    () => {
      api.repairOrders.show(basicRepairOrder.get(ID)).then(({ data }) => {
        const newRepair = {
          ...data,
          line_items: data.line_items
            .filter(l => l.repaired_line_item)
            .map(l => l.repaired_line_item)
        };
        setRepairOrder(fromJS(newRepair));
      });
    },
    [basicRepairOrder.get(ID)]
  );

  if (!repairOrder) return null;

  return (
    <React.Fragment>
      <h2 style={{ marginTop: 26 }}>Higher Assembly Section</h2>
      {/* eslint-disable */}
      <Table
        repairOrder={repairOrder}
        results={repairOrder.get("line_items").toJS()}
        startColumns={{
          "RO #": ({ lineItem }) => (
            <Link to={`/repair-orders/${lineItem.repair_order_id}`}>
              {lineItem.repair_order_code}
            </Link>
          )
        }}
        endColumns={{
          "Total Cost": ({ lineItem }) => dollars(Number(get(lineItem, "subtotal")))
        }}
        disabled
      />
      {/* eslint-enable */}
    </React.Fragment>
  );
}

const ifHasShopAssist = renderIf(({ repairOrder }) =>
  repairOrder
    .get("line_items", [])
    .some(l => l.get(ACTION_REQUESTED) === SHOP_ASSIST)
);

export default ifHasShopAssist(HigherAssemblyTable);

HigherAssemblyTable.propTypes = {
  repairOrder: T.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/HigherAssemblyTable.jsx